import React, { useState, useRef } from "react";
import SunEditor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Upload, message, Button } from "antd";
import { PlusOutlined, SaveOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import styled from "styled-components";
import axios from "axios";
import Page404 from "app/not-found";

const UploadProfile = styled(Upload)`
  .ant-upload {
    width: 50px !important;
    height: 50px !important;
  }
`;

const API_URL = process.env.REACT_APP_API_URL;

const PageAjouterArticle = () => {
  const { user } = useSelector((state) => state.user);
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState(() => {
    const d = new Date();
    const month = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];
    return `${d.getDate()} ${month[d.getMonth()]} ${d.getFullYear()}`;
  });
  const [categorie, setCategorie] = useState("Articles");
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const editorRef = useRef(null);

  // === UPLOAD AVATAR VERS LE SERVEUR ===
  const handleAvatarChange = async (info) => {
    const file = info.file.originFileObj || info.file;
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await axios.post(`${API_URL}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setAvatarPreview(res.data); // serveur doit retourner { url: "..." }
      message.success("Avatar uploadé !");
    } catch (err) {
      console.error(err);
      message.error("Erreur upload avatar");
    }
  };

  // === UPLOAD IMAGE SUNEDITOR VERS LE SERVEUR ===
  const onImageUploadBefore = async (files, info, uploadHandler) => {
    const file = files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await axios.post(`${API_URL}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // Retour attendu pour SunEditor
      const responseSunEditor = {
        result: [
          {
            url: res.data, // URL retournée par ton serveur
            name: file.name,
            size: file.size,
          },
        ],
      };
      uploadHandler(responseSunEditor);
    } catch (err) {
      console.error(err);
      message.error("Erreur upload image");
    }
  };

  function safeSlug(title) {
    return title
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/['%"]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  // === SAVE ARTICLE ===
  const handleSave = async () => {
    const editorHasContent =
      editorContent.replace(/<(.|\n)*?>/g, "").trim() !== "" ||
      /<img[\s\S]*?>/i.test(editorContent);

    if (!titre.trim() || !description.trim() || !date.trim() || !avatarPreview || !editorHasContent) {
      message.error("Vous devez entrer tous les champs");
      return;
    }

    try {
      const href = "/article/" + safeSlug(titre) + Date.now();
      await axios.post(`${API_URL}/api/articles/add`, {
        titre,
        description,
        categorie,
        href,
        date,
        image: avatarPreview,
        html: editorContent,
      });
      message.success("Enregistrement réussi !");
      window.location.reload();
    } catch (err) {
      console.error(err);
      message.error("Erreur lors de l’enregistrement : " + err.message);
    }
  };

  if (!user) return <Page404 />;

  return (
    <div style={{ padding: "20px" }}>
      <table>
        <tbody>
          <tr>
            <td>Catégorie:</td>
            <td>
              <select value={categorie} onChange={e => setCategorie(e.target.value)}>
                <option value="Articles">Articles</option>
                <option value="Projets">Projets</option>
                <option value="Propositions">Propositions</option>
                <option value="Événements">Événements</option>
                <option value="Conseils">Conseils</option>
                <option value="Photos">Photos</option>
              </select>
            </td>
            <td>Titre:</td>
            <td>
              <input
                type="text"
                value={titre}
                onChange={e => setTitre(e.target.value)}
                style={{ width: "500px" }}
              />
            </td>
            <td>Avatar:</td>
            <td>
              <UploadProfile
                name="avatar"
                listType="picture-circle"
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleAvatarChange}
                accept="image/*"
              >
                {avatarPreview ? (
                  <img
                    src={avatarPreview}
                    alt="Avatar"
                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                  />
                ) : (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Envoyer</div>
                  </div>
                )}
              </UploadProfile>
            </td>
          </tr>
          <tr>
            <td>Description:</td>
            <td colSpan={3}>
              <input
                type="text"
                value={description}
                onChange={e => setDescription(e.target.value)}
                style={{ width: "100%" }}
              />
            </td>
          </tr>
          <tr>
            <td>Date:</td>
            <td>
              <input
                type="text"
                value={date}
                onChange={e => setDate(e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <SunEditor
        ref={editorRef}
        setOptions={{
          buttonList: buttonList.complex,
          height: "600px",
          callBackSave: false,
          defaultTag: "p"
        }}
        onChange={content => setEditorContent(content)}
        onImageUploadBefore={onImageUploadBefore}
      />

      <div style={{ marginTop: "15px" }}>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          size="large"
          onClick={handleSave}
        >
          Enregistrer l'article
        </Button>
      </div>
    </div>
  );
};

export default PageAjouterArticle;
